<template>
  <div class="offcanvas offcanvas-end" :class="{'sent show': isSent}" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header" v-show="!isSent">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ title }}</h5>
    </div>
    <div class="offcanvas-body" v-if="!isSent">
      <vee-form v-slot="{ handleSubmit }" as="div">
        <form @submit.stop.prevent="handleSubmit(doConfirm)">
          <p>{{ $t('user.chooseTheAppropriatePermission') }}</p>

          <div class="form-floating v-select-floating">
            <v-select
              id="permission"
              class="v-select form"
              :placeholder="$t('user.permissions')"
              v-model="permissionSelected"
              data-test="vSelectPermission"
              :reduce="x => x.value"
              :options="permissionOptions"
              open-direction="below">
            </v-select>
            <label for="permission">{{ $t('user.permissions') }}</label>
          </div>
          <p>{{ $t('user.askForCollaboratorEmail') }}</p>
          <div class="form-floating">
            <vee-field name="email" v-model="email" rules="required|email" v-slot="{ field, errorMessage }">
              <input v-bind="field" class="form-control" type="email" id="email" :placeholder="$t('user.email')" ref="email" autocomplete="off" data-test="inputPermissionEmail" >
              <span class="vee-error">{{ errorMessage }}</span>
            </vee-field>
            <label for="email">{{ $t('user.email') }}</label>
          </div>

          <!-- footer inside body to avoid empty space between body and footer -->
          <div class="offcanvas-footer">
            <button type="submit" class="btn" :class="okButtonClass" data-test="btnConfirm">{{ okButton }}</button>
            <button type="button" class="btn" :class="cancelButtonClass" data-bs-dismiss="offcanvas" v-show="cancelButton" data-test="btnCancel" @click="doCancel">{{ cancelButton }}</button>
          </div>
        </form>
      </vee-form>
    </div>

    <div class="offcanvas-body" v-else>
      <div class="sent-box">
        <IconLetter/>
        <h1>{{ $t('user.sentInvitiationMessage') }}</h1>
        <p>{{ $t('user.sentInvitiationInfo') }}</p>
      </div>
    </div>

    <div class="offcanvas-footer" v-if="isSent">
      <button type="submit" class="btn btn-success" data-bs-dismiss="offcanvas" data-test="btnClose" @click="closeAndResolve">{{ $t('close') }}</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vee-error {
  width:                                100% !important;
}
.offcanvas {
  .offcanvas-body {
    p {
      font-size:                        var(--font-size-14);
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    0;
    }

    h1 {
      text-align:                       center;
      font-size:                        26px;
      line-height:                      normal;
    }

    p,
    h1 {
      color:                            var(--Brand-Primary, #1B294A);
      font-weight:                      300;
    }

    form {
      display:                          flex;
      flex-direction:                   column;
      gap:                              26px;
    }
    :deep(.vs__dropdown-menu) {
      top:                              100% !important;
      bottom:                           unset !important;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      // gap:                              10px;
      // flex:                             1 0 0;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
      // margin-top:                       26px;
    }
  }

  &.sent {
    padding:                            0;

    .offcanvas-body {
      display:                          flex;
      align-items:                      center;
      padding:                          40px;

      .sent-box {
        display:                        flex;
        flex-direction:                 column;
        justify-content:                center;
        align-items:                    center;
        gap:                            19px;
      }
    }

    .offcanvas-footer {
      padding:                          20px 40px;
      border-top:                       1px solid var(--Shades-30, #D8D8D8);
    }
  }
}
</style>

<script>
export default {
  name: 'BaseInvitationOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    title: null,
    text: null,
    okButton: null,
    okButtonClass: null,
    cancelButton: null,
    cancelButtonClass: null,
    offcanvas_invitation: null,
    email: null,
    permissionOptions: [],
    permissionSelected: 'admin',
    isSent: false,
  }),
  mounted() {
    this.permissionOptions = [
      {value: 'admin', label: this.$i18n.t('admin')},
      {value: 'physician', label: this.$i18n.t('physician')},
      {value: 'technician', label: this.$i18n.t('technician')},
      {value: 'specialist', label: this.$i18n.t('specialist')}
    ];
    // this.permissionSelected = this.exam.status
  },
  methods: {
    show(options = {}) {
      if (options.title)
        this.title = options.title

      if (options.text)
        this.text = options.text

      if (options.okButton) {
        this.okButton = options.okButton
        this.okButtonClass = options.okButtonClass
      }

      if (options.cancelButton) {
        this.cancelButton = options.cancelButton
        this.cancelButtonClass = options.cancelButtonClass
      }

      this.offcanvas_invitation = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.doInvite()
      // this.offcanvas_invitation = null;
      // this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_invitation = null;
      this.resolvePromise(false)
    },

    closeAndResolve() {
      this.isSent = false
      this.email = null
      this.offcanvas_invitation = null;
      this.resolvePromise(true)
    },

    async doInvite() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!emailRegex.test(this.email)) {
        this.$message.popup(this, 'createAccount.invalidEmail', 'validationError', 'error');
        return;
      }

      let params = {
        email: this.email,
        permissionType: this.permissionSelected
      }

      NProgress.start()
      try {
        let response = await this.$userService.invitation(params);
        this.$message.popup(this, 'user.sentInvitiationMessage', 'operationSuccess', 'success')

        this.isSent = true
      } catch (err) {
        if(err.response.data.errorMessage == 'conflict'){
          this.$message.popup(this, 'createAccount.colaboratorExists', 'operationWarning', 'warn')
        }
        else{
          this.$message.popup(this, 'operationFail', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'operationFail', 'danger')
        }
      }
      NProgress.done(true)
    }
  }
}
</script>
